import { ApiModel } from "./model.model";

export class ApiCompany extends ApiModel {
    Company: ApiCompany;
    record_type: string;
    name: string;
    company_ID: string;
    contact_ID: string;
    industry: string;
    website: string;
    revenue: string;
    type: string;
    sub_type: string;
    account_type: string;
    size: string;
    company_code: string;
    officemain_phone1: string;
    officemain_phone2: string;
    office_fax: string;
    contract_expiry_date: string;
    address1: string;
    address2: string;
    city: string;
    state: string;
    zip: string;
    country: string;
    notes: string;
    call_back_date: string;
    call_back_type: string;
    call_back_status: string;
}


// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/models/company.model.ts